import { InitClient,GetByParas,Post,PostWithParas} from "../ZeusAPIClient.js"
import { apiConfig } from "../../config.js"
import { Predicate } from "../Model/Predicate.js"
import { PagingBody } from "../Model/PagingBody.js"
InitClient(apiConfig.clientId,apiConfig.clientSecret,apiConfig.host);
//获取API列表
//predicates 条件参数
//pageIndex 页数
//pageSize 每页条数
//orderby 排序字段
//sort 升序 asc 降序 desc
async function GetApiPageList(predicates,pageIndex,pageSize,orderBy,sort)
{
    var pagingBody=new PagingBody(predicates,pageIndex,pageSize,orderBy,sort);
    return await Post('4ba5ed0a-6f43-4b50-91f6-e900dfc7ca08',pagingBody);
}


//添加接口
async function AddApi(apiModel){
    var data=await PostWithParas('c9a310f7-dc1e-4c11-b64b-409be7e4e330','',apiModel);
    if(data.Result==1){
        return true;
    }
    else{
        return false;
    }
  } 


export { 
    GetApiPageList,
    AddApi,
}